import { getStudySessionCards, type StudySessionCardsResult } from '@/lib/study'
import type { CollectionId } from '@/types/collections'
import type { StudySessionCard } from '@/types/study'
import type { CollectionEntity } from './types'

export type SessionCard = StudySessionCard
export type SessionCardsResult = StudySessionCardsResult

export type SessionOptions = {
  collection?: CollectionEntity | null
  curatedSlug?: string | null
  timeZone?: string
  now?: Date
}

export async function getSessionCards(
  collectionId: CollectionId,
  userId: string,
  options: SessionOptions = {}
): Promise<SessionCardsResult> {
  return getStudySessionCards(collectionId, userId, options)
}
